import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table } from "@mui/material";
import { totalRentConcept, totalRent } from "../../helpers/productsPrice";

export const CertificationServiceTable = ({ formValues }) => {

    const services = JSON.parse(formValues.product);

    return (
        <TableContainer component='div' >
            <Table sx={{ minWidth: 650 }} size='small' aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align='left'>Concepto</TableCell>
                        <TableCell align="center">Unidad</TableCell>
                        <TableCell align="center">Cantidad</TableCell>
                        <TableCell align='center'>Precio/día x ud</TableCell>
                        <TableCell align="right">Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {services.map(fields => (
                        <TableRow key={fields.id}>
                            <TableCell align='left'>{fields.product}</TableCell>
                            <TableCell align='center'>{fields.measure}</TableCell>
                            <TableCell align='center'>{fields.amount}</TableCell>
                            <TableCell align='center'>{fields.priceProduct}</TableCell>
                            <TableCell align='right'>{totalRentConcept(fields.amount, fields.priceProduct).toFixed(2)}€</TableCell>
                            
                        </TableRow>
                    ))}
                    <TableRow>
                        <TableCell align="left"></TableCell>
                        <TableCell align='center'></TableCell>
                        <TableCell align='center'></TableCell>
                        <TableCell align='center'><b>Suma:</b> </TableCell>
                        <TableCell align="right" sx={{ backgroundColor: '#D2D2D2' }}><b>{totalRent(services).toFixed(2)}€</b></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}
